import * as React from 'react';
import { Breadcrumbs } from '../../../Breadcrumbs/Breadcrumbs.old';
import styles from './styles.module.styl';
export var SearchResult = function (_a) {
    var id = _a.id, title = _a.title, url = _a.url, content = _a.content, description = _a.description, crumbs = _a.crumbs, isDocument = _a.isDocument, handleClick = _a.handleClick;
    var contentBody = description || content;
    return (React.createElement("div", { className: styles.searchResult, onClick: function (e) { return handleClick({ e: e, id: id, url: url, isDocument: isDocument }); } },
        React.createElement("h2", { className: styles.title },
            React.createElement("a", { href: url }, title)),
        crumbs && React.createElement(Breadcrumbs, { crumbs: crumbs }),
        contentBody && (React.createElement("p", { className: styles.description },
            React.createElement("a", { href: url, dangerouslySetInnerHTML: { __html: contentBody } })))));
};
